// src/app/app.initializers.ts
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ConfigService } from './services/config.service';
import { Observable } from 'rxjs';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/", `.json?cb=${new Date().getTime()}`);
}

export const configFactory = (config: ConfigService): (() => Observable<boolean>) => {
  return () => config.loadCompanyConfig();
};